module.exports = __webpack_public_path__ + "img/checkbox-on.fa300b4d.svg";